/* =========================================================
   NOBELIIS — scripts partagés pour les sections nb-*
   Chargé par chaque section ; le garde empêche une double initialisation.
   ========================================================= */
(function () {
  if (window.__nobeliisLoaded) return;
  window.__nobeliisLoaded = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var WISHLIST_KEY = 'nb-wishlist';

  /* ---------- Carrousels ---------- */
  function updateArrows(carousel) {
    var track = carousel.querySelector('.nb-carousel__track');
    if (!track) return;
    var prev = carousel.querySelector('.nb-carousel__arrow--prev');
    var next = carousel.querySelector('.nb-carousel__arrow--next');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }

  function initCarousels(scope) {
    (scope || document).querySelectorAll('.nb-carousel').forEach(function (carousel) {
      var track = carousel.querySelector('.nb-carousel__track');
      if (!track || track.dataset.nbBound) return;
      track.dataset.nbBound = '1';
      track.addEventListener('scroll', function () { updateArrows(carousel); }, { passive: true });
      updateArrows(carousel);
    });
  }

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('.nb-carousel__arrow');
    if (!arrow) return;
    var carousel = arrow.closest('.nb-carousel');
    var track = carousel.querySelector('.nb-carousel__track');
    var dir = arrow.classList.contains('nb-carousel__arrow--prev') ? -1 : 1;
    track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('.nb-carousel').forEach(updateArrows);
  });

  /* ---------- Liste de souhaits (locale au navigateur) ---------- */
  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (err) { return []; }
  }
  function writeWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (err) { /* stockage indisponible */ }
  }
  function paintWishlist(scope) {
    var list = readWishlist();
    (scope || document).querySelectorAll('.nb-card__wish').forEach(function (btn) {
      var active = list.indexOf(btn.dataset.handle) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.nb-card__wish');
    if (!btn) return;
    e.preventDefault();
    var list = readWishlist();
    var i = list.indexOf(btn.dataset.handle);
    if (i === -1) list.push(btn.dataset.handle); else list.splice(i, 1);
    writeWishlist(list);
    paintWishlist();
  });

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(message, withCartLink) {
    var el = document.querySelector('.nb-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'nb-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.innerHTML = '<span></span>' + (withCartLink ? '<a href="' + root + 'cart">Voir le panier</a>' : '');
    el.firstChild.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3500);
  }

  /* ---------- Ajout rapide au panier ---------- */
  function refreshCartCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-nb-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button.nb-card__add[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Erreur');
        toast('Ajouté au panier', true);
        return refreshCartCount();
      })
      .catch(function (err) { toast(err.message || 'Impossible d’ajouter ce produit', false); })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });

  /* ---------- Dialogues (Acheter le look, menu mobile, recherche) ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-nb-open]');
    if (opener) {
      var dlg = document.getElementById(opener.dataset.nbOpen);
      if (dlg && typeof dlg.showModal === 'function') {
        e.preventDefault();
        dlg.showModal();
        document.documentElement.style.overflow = 'hidden';
      }
      return;
    }
    var closer = e.target.closest('[data-nb-close]');
    if (closer) {
      var d = closer.closest('dialog');
      if (d) d.close();
      return;
    }
    // Clic sur l’arrière-plan du dialogue
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('nb-dialog')) e.target.close();
  });

  document.addEventListener('close', function (e) {
    if (e.target.tagName === 'DIALOG') document.documentElement.style.overflow = '';
  }, true);

  /* ---------- Barre d’annonce rotative ---------- */
  function initAnnouncements(scope) {
    (scope || document).querySelectorAll('[data-nb-rotator]').forEach(function (bar) {
      if (bar.dataset.nbBound) return;
      bar.dataset.nbBound = '1';
      var items = bar.querySelectorAll('.nb-announce__item');
      if (items.length < 2) return;
      var i = 0;
      setInterval(function () {
        if (window.matchMedia('(min-width: 990px)').matches) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4000);
    });
  }

  /* ---------- Diaporama ---------- */
  function slideIndex(track) {
    return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
  }
  function goToSlide(show, index) {
    var track = show.querySelector('.nb-slides__track');
    var count = track.children.length;
    if (!count) return;
    index = (index + count) % count;
    track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
  }
  function paintDots(show) {
    var track = show.querySelector('.nb-slides__track');
    var i = slideIndex(track);
    show.querySelectorAll('.nb-slides__dot').forEach(function (dot, d) {
      dot.classList.toggle('is-active', d === i);
      dot.setAttribute('aria-current', d === i ? 'true' : 'false');
    });
  }
  function initSlideshows(scope) {
    (scope || document).querySelectorAll('[data-nb-slideshow]').forEach(function (show) {
      if (show.dataset.nbBound) return;
      show.dataset.nbBound = '1';
      var track = show.querySelector('.nb-slides__track');
      var timer = null;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      track.addEventListener('scroll', function () {
        clearTimeout(track._nbDots);
        track._nbDots = setTimeout(function () { paintDots(show); }, 60);
      }, { passive: true });

      function start() {
        if (show.dataset.autoplay !== 'true' || reduced || track.children.length < 2) return;
        stop();
        timer = setInterval(function () { goToSlide(show, slideIndex(track) + 1); }, Number(show.dataset.speed) || 5000);
      }
      function stop() { clearInterval(timer); timer = null; }

      show.addEventListener('mouseenter', stop);
      show.addEventListener('mouseleave', start);
      show.addEventListener('focusin', stop);
      show.addEventListener('focusout', start);
      show.addEventListener('touchstart', stop, { passive: true });
      show._nbRestart = start;
      start();
    });
  }

  document.addEventListener('click', function (e) {
    var show = e.target.closest('[data-nb-slideshow]');
    if (!show) return;
    var track = show.querySelector('.nb-slides__track');
    if (e.target.closest('.nb-slides__arrow--prev')) goToSlide(show, slideIndex(track) - 1);
    else if (e.target.closest('.nb-slides__arrow--next')) goToSlide(show, slideIndex(track) + 1);
    else {
      var dot = e.target.closest('.nb-slides__dot');
      if (dot) goToSlide(show, Number(dot.dataset.index));
    }
  });

  // Éditeur de thème : afficher la diapositive sélectionnée
  document.addEventListener('shopify:block:select', function (e) {
    var show = e.target.closest && e.target.closest('[data-nb-slideshow]');
    if (!show) return;
    var slides = Array.prototype.slice.call(show.querySelector('.nb-slides__track').children);
    var i = slides.indexOf(e.target.closest('.nb-slides__slide'));
    if (i > -1) goToSlide(show, i);
  });

  /* ---------- Initialisation + éditeur de thème ---------- */
  function init(scope) {
    initCarousels(scope);
    paintWishlist(scope);
    initAnnouncements(scope);
    initSlideshows(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
